import tw from "twin.macro";
export const PrimaryButton = tw.button`px-10 py-5 font-bold rounded-full bg-customGrey text-customPurple hocus:cursor-pointer hocus:bg-customPinkLight hocus:text-white focus:shadow-outline focus:outline-none transition duration-300 border-0 no-underline`;
